import axios from "axios";
import { CONSENT_URL } from "./endpoints/consent";

async function getConsentStatus() {
  return await axios.get(CONSENT_URL.GetStatus, {
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
  });
}

async function submitConsent({ accepted } = { accepted: true }) {
  return await axios.post(
    CONSENT_URL.SubmitConsent,
    { accepted: Boolean(accepted) },
    {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    },
  );
}

export { getConsentStatus, submitConsent };
